import TextFieldResizable from './text-field-resizable';

export default TextFieldResizable;
